import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CouponsManagement from '../../pages/coupons/CouponsManagement';
import ReferralSystem from '../../pages/coupons/ReferralSystem';
import UserCouponsPage from '../../pages/coupons/UserCouponsPage';

const CouponsManagementSection: React.FC = () => {
  const [activeCouponsTab, setActiveCouponsTab] = useState('management');

  return (
    <div className='bg-white dark:bg-gray-800 rounded-lg shadow'>
      {/* Coupons Navigation */}
      <div className='border-b border-gray-200 dark:border-gray-700'>
        <nav className='flex space-x-8 space-x-reverse px-6'>
          {[
            { id: 'management', label: '🎫 إدارة الكوبونات' },
            { id: 'referrals', label: '🔗 نظام الإحالة' },
            { id: 'user-coupons', label: '👤 كوبونات المستخدمين' },
          ].map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveCouponsTab(tab.id)}
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeCouponsTab === tab.id
                  ? 'border-primary-500 text-primary-600 dark:text-primary-400'
                  : 'border-transparent text-secondary-500 hover:text-secondary-700 hover:border-secondary-300 dark:text-gray-400 dark:hover:text-gray-200'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Coupons Content */}
      <div className='p-6'>
        {activeCouponsTab === 'management' && <CouponsManagement />}
        {activeCouponsTab === 'referrals' && <ReferralSystem />}
        {activeCouponsTab === 'user-coupons' && <UserCouponsPage />}
      </div>

      {/* Quick Stats & Links */}
      <div className='bg-gradient-to-r from-purple-50 to-pink-50 dark:from-gray-800 dark:to-gray-700 px-6 py-4 border-t border-gray-200 dark:border-gray-700'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
          {/* Stats */}
          <div>
            <h4 className='font-medium text-gray-900 dark:text-white mb-3'>📊 إحصائيات سريعة</h4>
            <div className='grid grid-cols-2 gap-4'>
              <div className='text-center'>
                <div className='text-xl font-bold text-purple-600 dark:text-purple-400'>45</div>
                <div className='text-xs text-gray-600 dark:text-gray-400'>كوبونات نشطة</div>
              </div>
              <div className='text-center'>
                <div className='text-xl font-bold text-green-600 dark:text-green-400'>128</div>
                <div className='text-xs text-gray-600 dark:text-gray-400'>استخدامات هذا الشهر</div>
              </div>
              <div className='text-center'>
                <div className='text-xl font-bold text-blue-600 dark:text-blue-400'>23</div>
                <div className='text-xs text-gray-600 dark:text-gray-400'>إحالات جديدة</div>
              </div>
              <div className='text-center'>
                <div className='text-xl font-bold text-orange-600 dark:text-orange-400'>85%</div>
                <div className='text-xs text-gray-600 dark:text-gray-400'>معدل النجاح</div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className='font-medium text-gray-900 dark:text-white mb-3'>🔗 روابط سريعة</h4>
            <div className='space-y-2'>
              <Link 
                to='/admin/coupons'
                className='text-sm text-purple-600 hover:text-purple-700 dark:text-purple-400 flex items-center space-x-2 space-x-reverse'
              >
                <span>🎟️</span>
                <span>الصفحة المخصصة لإدارة الكوبونات</span>
              </Link>
              <Link 
                to='/referral'
                className='text-sm text-blue-600 hover:text-blue-700 dark:text-blue-400 flex items-center space-x-2 space-x-reverse'
              >
                <span>🌟</span>
                <span>نظام الإحالة والمكافآت</span>
              </Link>
              <Link 
                to='/coupons'
                className='text-sm text-green-600 hover:text-green-700 dark:text-green-400 flex items-center space-x-2 space-x-reverse'
              >
                <span>👥</span>
                <span>كوبونات المستخدمين</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CouponsManagementSection;